import {SampleControlsFeatureLevel} from 'inventory/sample-status/SampleControlsFeatureLevel';
import {hasMinimumSCRFeatureLevel} from 'inventory/sample-status/SampleControlsFeatureLevelUtil';

// todo(BNCH-57012): Move helper functions back to SampleStatusPresentationUtils.ts after SCR V2 rollout
// NOTE: Keep in sync with benchling/notebook/structured_tables/export/lookup_config_typed_value.py:get_restricted_sample_users_header_text
export function getRestrictedSampleUsersHeaderText(): string {
  return hasMinimumSCRFeatureLevel(SampleControlsFeatureLevel.V2)
    ? 'Restricted sample users'
    : 'Authorized users';
}

export function getRestrictedSampleUsersDisplayText(): string {
  return getRestrictedSampleUsersHeaderText().toLowerCase();
}

export function getEditRestrictedSampleUsersDisabledMessage(): string {
  return `You must ${
    hasMinimumSCRFeatureLevel(SampleControlsFeatureLevel.V2) ? 'have permission' : 'be a sample owner'
  } to edit ${getRestrictedSampleUsersDisplayText()}`;
}

export function getRemoveSampleRestrictionOrSampleOwnersWarningText(): string {
  return `This will also remove all ${getRestrictedSampleUsersDisplayText()} and allow anyone to use this container.`;
}
